import React from 'react';
import './styles.css';

export const ConfirmaSmsRodape = () => {
  return (
    <div>
      <a href="#">Reenviar Código</a>
    </div>
  );
};
